import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { fetchAssociatedIssues } from '../../services';
import { getIsLoading } from '../selectors';
import type { StoreApi, ContainerProps } from '../types';

const loadAssociatedIssue =
	() =>
	async ({ getState, setState }: StoreApi, { associatedIssueIds }: ContainerProps) => {
		if (getIsLoading(getState()) || !associatedIssueIds || associatedIssueIds.length === 0) {
			return;
		}
		setState({ isLoading: true });
		fetchAssociatedIssues(associatedIssueIds)
			.then((associatedIssues) => {
				setState({ associatedIssues, isLoading: false });
			})
			.catch((error) => {
				fireErrorAnalytics({
					meta: {
						packageName: 'jiraPortfolio3AssociatedIssues',
						id: 'fetchAssociatedIssues',
						teamName: 'jpd-juno',
					},
					error,
					sendToPrivacyUnsafeSplunk: false,
				});
			});
	};

export const actions = {
	loadAssociatedIssue,
};
